import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Apis } from "../../../lib/Apis";
import "../login-page/style.css";
import "./style.css";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Email required",
        text: "Please enter your registered email address.",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await Apis.forgotPassword({ email: email.trim() });
      const successMessage =
        response?.data?.message ||
        response?.data?.msg ||
        "OTP has been sent to your email.";

      await Swal.fire({
        icon: "success",
        title: "OTP sent",
        text: successMessage,
      });
      navigate(
        `/verify-otp?email=${encodeURIComponent(email.trim())}&isPasswordReset=true`
      );
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.response?.data?.msg ||
        "Unable to send OTP right now.";

      Swal.fire({
        icon: "error",
        title: "Request failed",
        text: message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-main-layout">
      <div className="auth-glass-box forgot-password-card">
        <form onSubmit={handleSubmit}>
          <h1>Forgot Password</h1>
          <p className="forgot-password-subtitle">
            Enter your email and we'll help you reset it.
          </p>
          <div className="auth-field-wrapper forgot-email-wrapper">
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <i className="bx bxs-envelope"></i>
          </div>
          <button type="submit" className="auth-login-action" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
          <button
            type="button"
            className="forgot-password-back"
            onClick={() => navigate("/login")}
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
